import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useConfirmation } from "go-form/components/ModalConfirm";
import { apiOrganization } from "../../../../../../../services/Api/Organization/apiOrganization";
import { InvoiceApi } from "../../../../../../../services/Api/Organization/types";
import { invoicePreviewIncludes } from "../pages/Index/Preview";
import { useCreateOfflineInvoiceReturn } from "../utils";

export const useCreateOfflineInvoice = (
	invoice: InvoiceApi | undefined,
	setInvoice: Dispatch<SetStateAction<InvoiceApi | undefined>>,
	onSuccess?: () => void | Promise<void>
): useCreateOfflineInvoiceReturn => {
	const [displayNoOfflineCertAlert, setDisplayNoOfflineCertAlert] = useState(false);
	const [offlineCreationLoading, setOfflineCreationLoading] = useState(false);
	const confirmation = useConfirmation();
	const { t } = useTranslation();
	const { addFlash, addSuccessFlash } = useFlash();
	const KSeFServiceUnavailable =
		invoice?.ksef_data?.error_code === "ksef_api_exception" && invoice?.ksef_data?.online;

	const createOfflineInvoiceHandler = async () => {
		if (!invoice) return;

		if (!invoice.settings.ksef_offline_certificate_exists) {
			setDisplayNoOfflineCertAlert(true);
			return;
		}

		try {
			await confirmation({
				title: t("lib:common.word.confirmation"),
				message: t("lib:confirmation.message.action"),
			});
			setOfflineCreationLoading(true);
			const offlineInvoice = await apiOrganization.crateOfflineKSeFInvoice(invoice.id, invoicePreviewIncludes);
			setInvoice(offlineInvoice);
			addSuccessFlash(t("lib:common.flash.completed"));
			if (onSuccess) {
				await onSuccess();
			}
		} catch (err) {
			handleError.alert(err, addFlash);
		} finally {
			setOfflineCreationLoading(false);
		}
	};

	return { createOfflineInvoiceHandler, offlineCreationLoading, KSeFServiceUnavailable, displayNoOfflineCertAlert };
};
